import React, {Component} from 'react';

import Helmet from 'react-helmet';
import Paragraph from '../Paragraph';
import Quote from '../Quote';
import Image from '../Image';
import Iframe from '../Iframe';
import Slider from '../Slider';

export default class Body extends Component {

    render() {
        const bodySections = this.buildBody(this.props.body);

        return (
            <div className="Body">
                {bodySections}
            </div>
        );
    }

    buildBody(body) {
        return body.map((data, index) => {
            return this.buildSection(data, index);
        });
    }

    buildSection(data, index) {
        switch (data.type) {
            case "Meta":
                return <Helmet key={index} htmlAttributes={{lang: "nl"}} {...data} />;
            case "Quote":
                return <Quote key={index} {...data} />;
            case "Paragraph":
                return <Paragraph key={index} {...data} />;
            case "Image":
                return <Image key={index} {...data} />;
            case "Iframe":
                return <Iframe key={index} {...data} />;
            case "Slider":
                return <Slider key={index} {...data} />;
            default:
                return null;
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/DetailPage/Body/index.js